module.exports = __webpack_public_path__ + "img/p-06.197ce1a1.webp";